import { UserRepository } from '../repositories/user-repository';
import { User } from '../entities/user-entity';

interface UserUsecase {
  CreateUser(name: string, email: string, mobile_no: string, password: string): Promise<User>;
  EditUser(user_id: string, name: string, email: string, mobile_no: string): Promise<User>;
  EditUserPassword(user_id: string, password: string): Promise<User>;
  GetUsers(): Promise<User[]>;
  GetUser(user_id: string): Promise<User>;
}

export class UserUsecaseImpl implements UserUsecase {
  userRepository: UserRepository;

  constructor(ur: UserRepository) {
    this.userRepository = ur;
  }

  CreateUser(name: string, email: string, mobile_no: string, password: string): Promise<User> {
    return this.userRepository.CreateUser(name, email, mobile_no, password);
  }

  EditUser(user_id: string, name: string, email: string, mobile_no: string): Promise<User> {
    return this.userRepository.EditUser(user_id, name, email, mobile_no);
  }

  EditUserPassword(user_id: string, password: string): Promise<User> {
    return this.userRepository.EditUserPassword(user_id, password);
  }

  GetUsers(): Promise<User[]> {
    return this.userRepository.GetUsers();
  }

  GetUser(user_id: string): Promise<User> {
    return this.userRepository.GetUser(user_id);
  }
}
